var $ = require("jquery");
var Cookies = require("js-cookie");

$(document).ready(function() {
  var bannerId = $(".banner .banner__content").data("banner-id");
  var bannerIds = [];

  if (typeof Cookies.get("banner-hidden") !== "undefined") {
    bannerIds = Cookies.get("banner-hidden").split(",");
  }

  if (bannerIds.includes(bannerId + "")) {
    return;
  }

  bannerIds.push(bannerId);

  $(".banner").css("display", "block");

  $(".banner .banner__button").on("click", function() {
    $(".banner").css("display", "none");
    Cookies.set("banner-hidden", bannerIds.join(","), { expires: 7 });
  });
});
